import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EmptyStateComponent } from './empty-state.component';
import { TranslateModule } from 'ng2-translate';


@NgModule({
    declarations: [
        EmptyStateComponent
    ],
    imports: [
        CommonModule,
        TranslateModule
    ],
    exports: [
        EmptyStateComponent
    ],
    entryComponents: [EmptyStateComponent],

    providers: []
})
export class EmptyStateModule { }



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/VyQQATNu/0/groupe-dev/nm17/node_modules/nm-socle-application/app/components/empty-state/empty-state.module.ts